/**
 * The chat routes, and which of them the unified shell's frame wraps (PLT-6610).
 *
 * Chat is a view inside the shell for an opted-in investor organisation — the top bar and the
 * rail stay up, the rail's Chats group is the conversation list, and a conversation is a URL of
 * its own so it can be linked, reloaded and gone back to. Outside the shell the same routes
 * render the full-screen chat with its own history sidebar, unchanged, until the rollout retires
 * it (PLT-6596).
 *
 * The paths live here rather than at their call sites because four files have to agree on them:
 * the route declarations, the frame switch (`use-unified-shell-frame-active.ts`), the frame's own
 * content column, and the rail rows that point at them.
 */

export const CHAT_PATH = '/chat';

/** The full conversation list inside the shell — the rail's `All chats` row. */
export const ALL_CHATS_PATH = '/chats';

/** The search on the Chats page, kept in the URL so Back from an opened chat returns to the results (PLT-7658). */
export const CHAT_SEARCH_PARAM = 'q';

/**
 * Router state a link to the Chats page sets to have its search field focused on arrival: the
 * rail's search shortcut (PLT-7658). State rather than a URL parameter, so a reload or a shared link
 * does not focus the field again.
 */
export const FOCUS_CHAT_SEARCH_STATE = 'focusChatSearch';

export function chatConversationPath(conversationId: string): string {
  return `${CHAT_PATH}/${conversationId}`;
}

/** `/chat` itself or one conversation under it. Not the list. */
export function isChatPath(pathname: string): boolean {
  return pathname === CHAT_PATH || pathname.startsWith(`${CHAT_PATH}/`);
}

/**
 * Every route the shell renders chat on. `/chats` is included: it is a page of the shell like
 * any other, and the frame has to be up for the rail to be beside it.
 */
export function isChatSurfacePath(pathname: string): boolean {
  return isChatPath(pathname) || pathname === ALL_CHATS_PATH;
}
